
import { useAuthContext } from '../contexts/AuthContext';
import { supabase } from '../lib/supabase';

// useAuth は AuthContext から状態を取得する（全コンポーネントで同一インスタンスを共有）
export function useAuth() {
  return useAuthContext();
}

export async function signInWithEmail(email: string, password: string) {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    return { data, error };
  } catch (e) {
    console.error('signInWithEmail unexpected error:', e);
    return { data: null, error: e as Error };
  }
}

export async function signUpWithEmail(email: string, password: string, username?: string) {
  try {
    const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
    const response = await fetch(`${supabaseUrl}/functions/v1/auto-confirm-signup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, username }),
    });

    const result = await response.json();

    if (!response.ok) {
      const msg = result.error || 'Registration failed';
      return { data: null, error: new Error(msg) };
    }

    const { data: signInData, error: signInError } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (signInError) return { data: null, error: signInError };
    return { data: signInData, error: null };
  } catch (e) {
    console.error('signUpWithEmail unexpected error:', e);
    return { data: null, error: e as Error };
  }
}

export async function signOut() {
  try {
    const { error } = await supabase.auth.signOut();
    return { error };
  } catch (e) {
    console.error('signOut unexpected error:', e);
    return { error: e as Error };
  }
}
